import { create } from 'zustand';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useResourceTagsStore = create()(delayedTrackZustand((set) => ({
  resourceId: null,
  setResourceId: (resourceId) => set({
    resourceId
  }),
  close: () => set({
    resourceId: null
  })
}), "resourceTags"));
const resourceTagsModal = {
  open: (variables) => {
    useResourceTagsStore.getState().setResourceId(variables.resourceId);
  },
  close: () => {
    useResourceTagsStore.getState().setResourceId(null);
  }
};

export { resourceTagsModal, useResourceTagsStore };
//# sourceMappingURL=resourceTagsStore.js.map
